<template>
    <div>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col cols="12">
                        <b-table-simple bordered responsive class="border-dark">
                            <b-thead class="text-center">
                                <b-tr class="bg-grey">
                                    <b-th>Title</b-th>
                                    <b-th>Token Amount</b-th>
                                    <b-th>Token Number</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr class="input-row">
                                    <b-td>Mortgage Specialist <br>Sales Executive <br>Sales Senior Advisor <br>Sales Support Executives</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.msp_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.msp_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                <b-tr class="input-row">
                                    <b-td>Sales Manager <br>Senior Advisor Manager <br>Sales Support Manager</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.sm_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.sm_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                <b-tr class="input-row">
                                    <b-td>Hub Manager</b-td>
                                    <b-td class="px-0">
                                        <b-input-group prepend="RM">
                                            <b-form-input type="text" v-model="token_form.hm_token_target_amount" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                    <b-td class="px-0">
                                        <b-input-group>
                                            <b-form-input type="number" v-model="token_form.hm_token_number" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="updateTokenSetting" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader,
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { useHubStore } from '@/stores/hubStore'

export default {
    mixins:[
        notifyFunctionMixin,
    ],
    components: {
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
    },
    
    data() {
        return {
            token_form: {
                hub_token_id: null,
                hub_id: null,
                msp_token_target_amount: null,
                msp_token_number: null,
                sm_token_target_amount: null,
                sm_token_number: null,
                hm_token_target_amount: null,
                hm_token_number: null,
            },
            hub_id: null,
        };
    },
    computed: {
        ...mapState(useHubStore,['current_hub', 'current_team'])
    },
    created() {
        this.getHubTokenSetting();
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        getHubTokenSetting() {
            if(this.current_hub)
            {
                this.hub_id = this.current_hub.hub_id
            }
            else
            {
                this.hub_id = this.current_team.hub.hub_id
            }
            axios.get(services.hub + 'hub_comms/hub_token/' + this.hub_id, {headers: getHeader()})
            .then(res => {
                if(res.data.data.length > 0)
                {
                    this.token_form = res.data.data[0];
                }
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        updateTokenSetting() {
            console.log('token');
            const postData = this.token_form;

            if(this.token_form.hub_token_id)
            {
                axios.put(services.hub + 'hub_comms/hub_token/' + this.token_form.hub_token_id, postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Token Setting </b> - Successfully Updated.')
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
            else
            {
                axios.post(services.hub + 'hub_comms/hub_token', postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Token Setting </b> - Successfully Created.')
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
        },
        
    }
}
</script>